import _ from 'lodash';
import { batch } from 'react-redux';

import { addError, handleErrors } from './ErrorActions';
import {
  getEnhancedGlobalSearchExport,
  getEnhancedGlobalSearchResults,
} from '../api/global-search';
import { getAppOptionByKey } from '../selectors/AppConfigsSelectors';
import { downloadFile } from '../utils/domUtils';
import { isNilOrEmpty } from '../utils/ramdaUtils';

const globalSearchParams = {
  pageSize: 25,
  sortExpression: 'OBJ_MODIFIED_DATE DESC',
};

export const RESET_SEARCH_RESULTS = 'SearchPageActions/RESET_SEARCH_RESULTS';

export const FETCH_ENHANCED_SEARCH_RESULTS_PAGE =
  'SearchPageActions/FETCH_ENHANCED_SEARCH_RESULTS_PAGE';
export const FETCH_ENHANCED_SEARCH_RESULTS_PAGE_SUCCESS =
  'SearchPageActions/FETCH_ENHANCED_SEARCH_RESULTS_PAGE_SUCCESS';
export const FETCH_ENHANCED_SEARCH_RESULTS_PAGE_FAILURE =
  'SearchPageActions/FETCH_ENHANCED_SEARCH_RESULTS_PAGE_FAILURE';

export const FETCH_ADVANCED_CRITERIA_SUCCESS = 'FETCH_ADVANCED_CRITERIA_SUCCESS';

export const MAKE_ENHANCED_SEARCH_ADVANCED = 'MAKE_ENHANCED_SEARCH_ADVANCED';

export const makeEnhancedSearchAdvanced = (payload) => ({
  type: MAKE_ENHANCED_SEARCH_ADVANCED,
  payload,
});

export const resetSearchResults = () => ({
  type: RESET_SEARCH_RESULTS,
});

export const fetchAdvancedCriteriaSuccess = (payload) => ({
  type: FETCH_ADVANCED_CRITERIA_SUCCESS,
  payload,
});

const fetchEnhancedSearchResultsPageFailure = (error) => ({
  type: FETCH_ENHANCED_SEARCH_RESULTS_PAGE_FAILURE,
  error,
});

const fetchEnhancedSearchResultsPageSuccess = (payload) => ({
  type: FETCH_ENHANCED_SEARCH_RESULTS_PAGE_SUCCESS,
  payload,
});

export const fetchEnhancedSearchResultsPage = ({
  entityNames = [],
  sortExpression = globalSearchParams.sortExpression,
  searchText = '',
  searchOption = 0,
  pageSize = 25,
  getCrossReferences = false, // default value??
  advancedSearchCriteria = [],
  useContainsTable = false,
  page = 0,
}) => async (dispatch, getState) => {
  const allowEnhancedGlobalSearch = getAppOptionByKey('allowEnhancedGlobalSearch')(getState());

  const data = {
    entityNames,
    sortExpression,
    searchText,
    searchOption,
    currentPageIndex: page,
    pageSize,
    getCrossReferences,
    advancedSearchCriteria,
    useContainsTable,
  };

  const dataPayload = Object.assign({}, data);

  if (allowEnhancedGlobalSearch) {
    _.set(
      dataPayload,
      'advancedSearchCriteria',
      dataPayload?.advancedSearchCriteria?.filter((e) => !isNilOrEmpty(e?.Value))
    );
  } else {
    _.unset(dataPayload, 'advancedSearchCriteria');
  }

  dispatch({
    type: FETCH_ENHANCED_SEARCH_RESULTS_PAGE,
    payload: data,
  });

  try {
    const response = await getEnhancedGlobalSearchResults(dataPayload);

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      dispatch(
        fetchEnhancedSearchResultsPageFailure(new Error('Failed to fetch global search results'))
      );
      return;
    }

    const { Rows: rows, TotalResultCount: totalResultCount } = response.EnhancedGlobalSearchData;
    const totalPages = Math.ceil(totalResultCount / pageSize);

    dispatch(
      fetchEnhancedSearchResultsPageSuccess({
        rows,
        totalResultCount,
        page,
        totalPages,
        searchText,
      })
    );
  } catch (error) {
    batch(() => {
      dispatch(fetchEnhancedSearchResultsPageFailure(error));
      dispatch(addError(error));
    });
  }
};

export const getGlobalSearchExport = (exportParameters) => async (dispatch, getState) => {
  const allowEnhancedGlobalSearch = getAppOptionByKey('allowEnhancedGlobalSearch')(getState());
  const dataPayload = Object.assign({}, exportParameters);

  if (allowEnhancedGlobalSearch) {
    _.set(
      dataPayload,
      'advancedSearchCriteria',
      dataPayload?.advancedSearchCriteria?.filter((e) => !isNilOrEmpty(e?.Value))
    );
  } else {
    _.unset(dataPayload, 'advancedSearchCriteria');
  }

  try {
    const response = await getEnhancedGlobalSearchExport(dataPayload);

    let containsErrors;

    try {
      containsErrors = JSON.parse(await response.text());
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Failed to parse json getGlobalSearchExport');
    }

    if (containsErrors?.hasError) {
      dispatch(handleErrors(containsErrors?.errors));
    } else {
      const filename = 'exportedsearch';
      downloadFile(`${filename}.xlsx`, response, 0);
    }
  } catch (error) {
    dispatch(handleErrors(error));
  }
};
